import React, { Component } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  Divider,
  MenuItem,
} from "@mui/material";
import Sidebar from "./Sidebar";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import base from "../base.json";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Appbar from "./Appbar";




const drawerWidth = 80;
export class Builder_profile extends Component {
  constructor(props) {
    super(props);
    this.state = {

        builder_name : "",

    builder_address: "",
    builder_contact_no: "",

    builder_second_contact_no: "",
    builder_email_id: "",

    builder_logo : "",
    builder_description: "",
    
    builder_login_passcode: "",
      

      is_switch_case: true,
    };
    this.handleChange = this.handleChange.bind();
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleChangee = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };

  handleChangeee = (e) => {
    this.setState({
      [e.target.name]: e.target.files,
    });
  };



async componentDidMount(){
  //// retrive details

   let  m =  await sessionStorage.getItem("data")
    let  ll = JSON.parse(m)
fetch(`${base.base_url}/property_portal/vendor_portal/builder/retriveBuilderDetails`, {
      headers:{
    'content-type':'application/json',
   // 'Access-Control-Allow-Origin': 'http://localhost:3000',
      },
          method: "post",
          body:JSON.stringify({
            id: ll[0].builder_id
          })
        }).then(function(response) {
          return response.json();
        })
        .then((data)=> {
         this.setState({
           
          
      builder_name : data.data.builder_name,

    builder_address: data.data.builder_address,
    builder_contact_no: data.data.builder_contact_no,

    builder_second_contact_no: data.data.builder_second_contact_no,
    builder_email_id: data.data.builder_email_id,

    builder_logo : data.data.builder_logo,
    builder_description: data.data.builder_description,
    
    builder_login_passcode: data.data.builder_login_passcode,
         
         })
        });

}




instantRetrive=async()=>{
  
   let  m =  await sessionStorage.getItem("data")
    let  ll = JSON.parse(m)
fetch(`${base.base_url}/property_portal/vendor_portal/builder/retriveBuilderDetails`, {
      headers:{
    'content-type':'application/json',
   // 'Access-Control-Allow-Origin': 'http://localhost:3000',
      },
          method: "post",
          body:JSON.stringify({
            id: ll[0].builder_id
          })
        }).then(function(response) {
          return response.json();
        })
        .then((data)=> {

         this.setState({
          
      builder_name : data.data.builder_name,

    builder_address: data.data.builder_address,
    builder_contact_no: data.data.builder_contact_no,

    builder_second_contact_no: data.data.builder_second_contact_no,
    builder_email_id: data.data.builder_email_id,

    builder_logo : data.data.builder_logo,
    builder_description: data.data.builder_description,
    
    builder_login_passcode: data.data.builder_login_passcode,
         
         })

        });

      
}

  
  save =async() => {

       let  m =  await sessionStorage.getItem("data")
    let  ll = JSON.parse(m)
    
    if (
             this.state.builder_name != "",

    this.state.builder_address!= "",
    this.state.builder_contact_no!= "",

    this.state.builder_second_contact_no!= "",
    this.state.builder_email_id!= "",

    this.state.builder_logo != "",
    this.state.builder_description!= "",
    
    this.state.builder_login_passcode!= ""

    ) {

      let formdata = new FormData();

      formdata.append("builder_name", this.state.builder_name);
      formdata.append(
        "builder_address",
        this.state.builder_address
      );
 

      formdata.append("builder_contact_no", this.state.builder_contact_no);
         formdata.append("builder_second_contact_no", this.state.builder_second_contact_no);
    
      formdata.append(
        "builder_email_id",
        this.state.builder_email_id
      );
        formdata.append("id",ll[0].builder_id);
      formdata.append("builder_logo", this.state.builder_logo);
      formdata.append("builder_description", this.state.builder_description);
      formdata.append("builder_login_passcode", this.state.builder_login_passcode);
     

      this.setState({ is_loader_shows: true }, () => {
        fetch(
          `${base.base_url}/property_portal/vendor_portal/builder/updateBuilderDetails`,
          {
            /*
        headers: {
                                "content-type": "multipart/form-data",
                              },
                              */
            method: "put",
            body: formdata,
          }
        )
          .then((res) => {
            return res.json();
          })
          .then(() => {
            alert("done");
          });
      });
    } else {
      alert("fill all fields");
    }

  };
  

  render() {
    return (
      <Box>
        <Appbar/>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            <Box
              sx={{
                height: 47,
                //  width: "100%",
                backgroundColor: "#fff",
                borderRadius: 0,
                mt: 0.2,
                borderBottom: 0.5,
                borderBottomColor: "#dddddd",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: 18, ml: 1 }}>
                Update Profile
              </Typography>

      
            </Box>

            <Box
              sx={{
                pl: { xs: 1, sm: 3 },
                pt: { xs: 1, sm: 3 },
                pr: { xs: 1, sm: 3 },
                display: this.state.is_switch_case ? "block" : "none",
              }}
            >
              <Box>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                    Company/Builder details
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Builder name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Builder name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_name"
                          value={this.state.builder_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Builder Address
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Adress"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_address"
                          value={this.state.builder_address}
                          onChange={this.handleChange}
                             />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Builder contact no
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="contact no"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_contact_no"
                          value={this.state.builder_contact_no}
                          onChange={this.handleChange}
                           />

                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         Second contact no
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="contact no"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_second_contact_no"
                          value={this.state.builder_second_contact_no}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Builder Email ID
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Email"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_email_id"
                          value={this.state.builder_email_id}
                          onChange={this.handleChange}
                        />
                      </Grid>

                   

                         <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         Description
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="builder_description"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_description"
                          value={this.state.builder_description}
                          onChange={this.handleChange}
                        />
                      </Grid>


                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         password
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Password"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="builder_login_passcode"
                          value={this.state.builder_login_passcode}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Logo
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            name="builder_logo"
                            onChange={this.handleChangee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                      </Grid>

             
                    </Grid>

    

                    <br />

                    <Box>
                      <Button
                        size="small"
                        variant="contained"
                        sx={{ textTransform: "none", fontSize: 12 }}
                        onClick={this.save}
                      >
                        Update Builder Details
                      </Button>
                    </Box>
                  </Box>
                </Paper>
              </Box>

              <br />
              <br />
              <br />
            </Box>
          </Box>
        </Box>
      </Box>
      </Box>
    );
  }
}

export default Builder_profile;

export function Builder_profilec(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams();
  return <Builder_profile param={param} navigate={navigate}></Builder_profile>;
}




 

